import React, { useState } from 'react';
import ItemsCarousel from 'react-items-carousel';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import { Box, Flex, Heading, Text, Image } from '@chakra-ui/core';
import { IoIosArrowForward, IoIosArrowBack, IoIosClose } from 'react-icons/io';

import ActionButton from '../../../components/helpers/ActionButton';
import { DownloadIcon } from '../../../components/Icons';
import { formatDollar } from '../../../utils/CurrencyFormatter';

const PendingOrderCard = ({
  orders,
  menuOpen,
  session,
  setSession,
  setUnexpectedError,
  downloadPDF,
  deleteOrder,
  token,
  firstName
}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [deletedOrder, setDeletedOrder] = useState(null);
  const [isSubmittingA, setIsSubmittingA] = useState(false);
  const [isSubmittingB, setIsSubmittingB] = useState(false);
  const chevronWidth = 40;

  if (deletedOrder) {
    orders = orders.filter(order => order._id !== deletedOrder._id);
  }

  return (
    <Box bg="cf.200" px={{ lg: 48 }} py={16} pl={{ base: 14, md: 20 }} pr={{ base: 4, md: 5 }}>
      <Flex wrap="wrap">
        <Heading as="h3">Pending Orders</Heading>
        <Box style={{ padding: `0 ${chevronWidth}px` }} className="w-full md:w-2/3">
          <ItemsCarousel
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={1}
            leftChevron={<IoIosArrowBack size={chevronWidth} color="#3c9130" />}
            rightChevron={<IoIosArrowForward size={chevronWidth} color="#3c9130" />}
            outsideChevron
            chevronWidth={chevronWidth}
          >
            {orders.map(order => (
              <Flex key={order._id} justify="center" align="center">
                <Box>
                  <Image
                    src={order.imageUrl}
                    alt={order.crop}
                    className="inline-block h-16  w-16 mr-4 md:h-32 md:w-32 object-cover"
                  />
                </Box>
                <Box className="text-xs">
                  <Heading as="h5">{order.crop}</Heading>
                  <Text as="p">Invoice #: {order.refKey}</Text>
                  <Text as="p">{order.acreage} Acre(s) | Farm Insurance Included</Text>
                  <Text as="p">{formatDollar(order.cost)}</Text>
                  <Flex warp="wrap" justify="end">
                    <>
                      {order.invoice ? (
                        <a href={order.invoice} download>
                          <ActionButton
                            name="Invoice"
                            color="bg-cf-300"
                            textColor="text-white"
                            icon={
                              <DownloadIcon
                                styles={{
                                  margin: '2px 5px 0 0',
                                  size: '12px',
                                  verticalAlign: 'middle'
                                }}
                              />
                            }
                            btnPad={'md:px-4 md:py-3 p-1'}
                            className="mr-1"
                          />
                        </a>
                      ) : (
                        <ActionButton
                          isSubmitting={isSubmittingA}
                          name="Invoice"
                          color="bg-cf-300"
                          textColor="text-white"
                          icon={
                            <DownloadIcon
                              styles={{
                                margin: '2px 5px 0 0',
                                size: '12px',
                                verticalAlign: 'middle'
                              }}
                            />
                          }
                          click={async () => {
                            if (session)
                              try {
                                setIsSubmittingA(true);
                                const response = await downloadPDF(order._id, 'invoice', token);
                                setIsSubmittingA(false);
                                if (response.status === 200) {
                                  const pdfBlob = new Blob([response.data], {
                                    type: 'application/pdf'
                                  });
                                  saveAs(pdfBlob, `${order.refKey}-invoice-for-${firstName}.pdf`);
                                  toast.success('Download Completed', {
                                    position: toast.POSITION.TOP_RIGHT
                                  });
                                } else {
                                  toast.error('Failed to download, Retry!', {
                                    position: toast.POSITION.TOP_RIGHT
                                  });
                                }
                              } catch (error) {
                                if (error && error.status === 401) setSession(false);
                                else setUnexpectedError('Unexpected Server Error!');
                              }
                          }}
                          btnPad={'md:px-4 md:py-3 p-1'}
                          className="mr-1"
                        />
                      )}
                    </>
                    <ActionButton
                      isSubmitting={isSubmittingB}
                      color="bg-red-200"
                      textColor="text-red-600"
                      name="Cancel"
                      icon={<IoIosClose size={20} />}
                      click={async () => {
                        if (session)
                          try {
                            setIsSubmittingB(true);
                            const response = await deleteOrder(order._id);
                            setIsSubmittingB(false);
                            if (response.code === 200) {
                              setDeletedOrder(response.data);
                              toast.success(response.message, {
                                position: toast.POSITION.TOP_RIGHT
                              });
                              // toast.info('You can revert this now or never!', {
                              //   position: toast.POSITION.TOP_RIGHT
                              // });
                            } else {
                              toast.error(response.data.message, {
                                position: toast.POSITION.TOP_RIGHT
                              });
                            }
                          } catch (error) {
                            console.log(error);
                            if (error && error.status === 401) setSession(false);
                            else setUnexpectedError('Unexpected Server Error!');
                          }
                      }}
                      btnPad={'md:px-4 md:py-3 p-1'}
                    />
                  </Flex>
                </Box>
              </Flex>
            ))}
          </ItemsCarousel>
        </Box>
      </Flex>
    </Box>
  );
};

export default PendingOrderCard;
